import React from 'react';
import MenuItem from '../menu_item';
import MenuSection from '../menu_section';
export var isMenuItem = child => {
  return /*#__PURE__*/React.isValidElement(child) && child.type === MenuItem;
};
export var isMenuSection = child => {
  return /*#__PURE__*/React.isValidElement(child) && child.type === MenuSection;
};
export var extractOrderedValues = children => {
  var values = [];
  React.Children.forEach(children, child => {
    if (isMenuItem(child) && !child.props.disabled) {
      values.push({
        value: child.props.value,
        label: child.props.label
      });
    } else if (isMenuSection(child)) {
      values.push(...extractOrderedValues(child.props.children));
    }
  });
  return values;
};
export var hasChildWithIcon = children => {
  var _React$Children$map;
  return ((_React$Children$map = React.Children.map(children, child => {
    if (isMenuItem(child)) {
      return !!child.props.leadingArea;
    }
    if (isMenuSection(child)) {
      return hasChildWithIcon(child.props.children);
    }
  })) === null || _React$Children$map === void 0 ? void 0 : _React$Children$map.some(x => x)) || false;
};